// utils/mockScoringData.js

export const getScoringMatrixConfig = (electionTypeId) => {
  switch (electionTypeId) {
    case 1: // Corresponding Membership
      return {
        type: 'corresponding',
        criteria: [
          {
            key: 'scientificExcellence',
            label: 'Scientific Excellence',
            description: 'Score out of 50',
            min: 0,
            max: 50,
          },
          {
            key: 'internationalProfile',
            label: 'International profile',
            description: 'Score out of 30',
            min: 0,
            max: 30,
          },
          {
            key: 'connectionToAustralian',
            label: 'Connection to Australian Science',
            description: 'Score out of 20',
            min: 0,
            max: 20,
          },
        ],
        introduction:
          'Noting that all three criteria will be used in the final short-listing, the final consideration for Council will be based on the third criterion. Corresponding Members are expected to have a strong connection with Australia and to be able to advance the work of the Academy in science education, advocacy or policy.',
      };
    case 2:
      return {
        type: 'sectional',
        criteria: [
          {
            key: 'scientificLeadership',
            label: 'Scientific Achievement',
            description: 'Score out of 60 (can be adjusted to 85)',
            min: 0,
            max: 60,
            adjustedMax: 85,
          },
          {
            key: 'nationalProfile',
            label: 'National and International profile',
            description: 'Score from 10 to 20 (can be adjusted to 10-35)',
            min: 10,
            max: 20,
            adjustedMax: 35,
          },
          {
            key: 'leadershipMentorship',
            label: 'Leadership, Mentorship and Promotion of Science',
            description: 'Score from 5 to 20 (can be adjusted to 5-30)',
            min: 5,
            max: 20,
            adjustedMax: 30,
          },
        ],
        introduction:
          "Please score each candidate against each of the three indicators of merit below (a higher score will indicate a better score). Normally the weighting used would be 60:20:20 and any changes used by a committee need to be commented on in the Chair's report to Council.",
      };
    case 3:
      return {
        type: 'special',
        criteria: [
          {
            key: 'serviceToScience',
            label: 'Service to Science',
            description: 'Score out of 50',
            min: 0,
            max: 50,
          },
          {
            key: 'nationalProfile',
            label: 'National and International profile',
            description: 'Score out of 30',
            min: 0,
            max: 30,
          },
          {
            key: 'academyVision',
            label: "Supporting the Academy's Vision",
            description: 'Score out of 20',
            min: 0,
            max: 20,
          },
        ],
        introduction:
          'Specially elected Fellows will have: rendered conspicuous service to the cause of science, OR demonstrated outstanding innovation or entrepreneurial spirit through the translation of the results of scientific research that have led to global impact.',
      };
    default:
      return getScoringMatrixConfig(2);
  }
};
